export enum CreateUserSuccess {
  SUCCESS = 201,
}

export enum CreateUserError {
  INFOMATION_INVALID = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  USER_ALREADY_EXISTS = 409,
  INTERNAL_SERVER_ERROR = 500,
}

export const CreateUserSuccessDefined = {
  [CreateUserSuccess.SUCCESS]: {
    message: 'Tạo mới thành công',
  },
};

export const CreateUserErrorDefined = {
  [CreateUserError.INFOMATION_INVALID]: {
    message:
      'Thông tin không hợp lệ, PC này không tồn tại trưởng nhóm, Tạo mới thất bại',
  },
  [CreateUserError.UNAUTHORIZED]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [CreateUserError.FORBIDDEN]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [CreateUserError.USER_ALREADY_EXISTS]: {
    message:
      'Tài khoản đã tồn tại, Điện lực này đã tồn tại tài khoản, PC này đã tồn tại trưởng nhóm',
  },
  [CreateUserError.INTERNAL_SERVER_ERROR]: {
    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau',
  },
};
